<template>
  <v-container grid-list-xl>
    <v-layout
      wrap
    >
      <service-table
        v-for="table in tables"
        :key="table.title"
        :title="table.title"
        :headers="table.headers"
        :rows="table.rows"
      />
      <v-flex
        xs12
        md10
        class="offset-md-1"
      >
        <v-sheet
          class="pa-8"
          tile
        >
          <h2 class="display-1 primary--text mb-2">
            Podsumowanie
          </h2>
          <v-simple-table>
            <thead>
              <tr>
                <th
                  class="text-left"
                >
                  Typ
                </th>
                <th
                  class="text-left"
                >
                  Ilość
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in summary"
                :key="item.title"
              >
                <td>{{ item.title }}</td>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-sheet>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
export default {
  name: 'EServices',
  components: {
    ServiceTable: () => import('@/components/ServiceTable')
  },
  data: () => ({
    tables: undefined,
    publicPath: process.env.BASE_URL
  }),
  computed: {
    summary: function () {
      return [{
        'title': 'Liczba usług publicznych udostępnionych on-line o stopniu dojrzałości co najmniej 3',
        'value': this.level3
      },
      {
        'title': 'Liczba usług publicznych udostępnionych on-line o stopniu dojrzałości co najmniej 4',
        'value': this.level4
      },
      {
        'title': 'Liczba usług publicznych udostępnionych on-line o stopniu dojrzałości co najmniej 5',
        'value': this.level5
      },
      {
        'title': 'Liczba usług udostępnionych on-line dla administracji (A2A)',
        'value': this.a2a
      },
      {
        'title': 'Liczba usług udostępnionych on-line dla biznesu (A2B)',
        'value': this.a2b
      },
      {
        'title': 'Liczba usług udostępnionych on-line dla osób fizycznych (A2C)',
        'value': this.a2c
      }]
    },
    a2a: function () {
      let number = 0
      if (typeof this.tables !== 'undefined') {
        for (let i = 0; i < this.tables.length; i++) {
          number += this.tables[i].rows.filter(row => row.groups.includes('A2A')).length
        }
      }
      return number
    },
    a2b: function () {
      let number = 0
      if (typeof this.tables !== 'undefined') {
        for (let i = 0; i < this.tables.length; i++) {
          number += this.tables[i].rows.filter(row => row.groups.includes('A2B')).length
        }
      }
      return number
    },
    a2c: function () {
      let number = 0
      if (typeof this.tables !== 'undefined') {
        for (let i = 0; i < this.tables.length; i++) {
          number += this.tables[i].rows.filter(row => row.groups.includes('A2C')).length
        }
      }
      return number
    },
    level5: function () {
      let number = 0
      if (typeof this.tables !== 'undefined') {
        for (let i = 0; i < this.tables.length; i++) {
          number += this.tables[i].rows.filter(row => row.level === 5).length
        }
      }
      return number
    },
    level4: function () {
      let number = this.level5
      if (typeof this.tables !== 'undefined') {
        for (let i = 0; i < this.tables.length; i++) {
          number += this.tables[i].rows.filter(row => row.level === 4).length
        }
      }
      return number
    },
    level3: function () {
      let number = this.level4
      if (typeof this.tables !== 'undefined') {
        for (let i = 0; i < this.tables.length; i++) {
          number += this.tables[i].rows.filter(row => row.level === 3).length
        }
      }
      return number
    }
  },
  created () {
    axios
      .get(`${this.publicPath}api/services.json`)
      .then(response => (this.tables = response.data))
  }
}
</script>
